import axios from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでファイルのアップロードが成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosPost(url: string, formData: FormData, token?: string) {
  if (token) {
    return axios.post(url, formData, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.post(url, formData);
  }
}

export interface IUploadFilesParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * ファイルオブジェクトの配列
   */
  files: File[];
}

/**
 * ファイルをアップロードします
 * @function uploadFiles
 * @param {IUploadFilesParams} params - ファイルアップロードパラメータ
 */
export function uploadFiles(params: IUploadFilesParams): void {
  const { authService, projectid, files } = params;
  const url = WebAPI.UPLOAD_DATAFILE(projectid);
  if (authService) {
    const promises = files.map((file) => {
      const formData = new FormData();
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        authService.getToken({
          success: (token) => {
            AxiosPost(url, formData, token)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          },
          fail: (err) => {
            reject(err);
          },
        });
      });
    });
    Promise.all(promises)
      .then(() => {
        params.success(200);
      })
      .catch((err) => {
        const { id, status } = getErrorStatus(err);
        if (status === 401) {
          uploadFilesRetry401(authService, url, files, params);
        } else {
          params.fail(id, status);
        }
      });
  } else {
    const promises = files.map((file) => {
      const formData = new FormData();
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        AxiosPost(url, formData)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    });
    Promise.all(promises)
      .then(() => {
        params.success(200);
      })
      .catch((err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      });
  }
}

/**
 * ファイルをアップロードします
 * @function uploadFilesRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {File[]} files - ファイルオブジェクトの配列
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function uploadFilesRetry401(
  authService: AuthService,
  url: string,
  files: File[],
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      const promises = files.map((file) => {
        const formData = new FormData();
        formData.append("file", file);
        return new Promise((resolve, reject) => {
          AxiosPost(url, formData, token)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promises)
        .then(() => {
          params.success(200);
        })
        .catch((err) => {
          const { id, status } = getErrorStatus(err);
          params.fail(id, status);
        });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
